document.addEventListener("DOMContentLoaded", function () {

    const sticky = document.getElementById("sticky-atc");
    if (!sticky) return;

    sticky.classList.add("show");

    const cartBtn = document.getElementById("StickyAddToCart");
    const buyBtn = document.getElementById("StickyBuyNow");
    const soldBtn = document.getElementById("StickySoldOut");
    const buttons = document.getElementById("StickyButtons");

    /* =========================================
       ADD TO CART
    ========================================= */

    cartBtn?.addEventListener("click", function () {

        const addButton = document.querySelector('button[name="add"]');

        if (!addButton || addButton.disabled) return;

        /* Start loading animation */
        cartBtn.classList.add("atha-sticky-loading");
        cartBtn.disabled = true;

        /* Trigger native Dawn Add to Cart */
        addButton.click();

    });


    /* =========================================
       BUY NOW
    ========================================= */

    buyBtn?.addEventListener("click", function () {

        const buyButton = document.querySelector(
            ".shopify-payment-button button"
        );

        if (!buyButton) return;

        buyBtn.classList.add("atha-sticky-loading");
        buyBtn.disabled = true;

        buyButton.click();

    });


    /* =========================================
       STOP LOADING AFTER CART UPDATE
    ========================================= */

    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {

        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {

            cartBtn?.classList.remove("atha-sticky-loading");
            cartBtn?.removeAttribute("disabled");

            buyBtn?.classList.remove("atha-sticky-loading");
            buyBtn?.removeAttribute("disabled");

        });

    }


    /* =========================================
       FALLBACK - STOP LOADING
       If Dawn doesn't publish cartUpdate
    ========================================= */

    setTimeout(function () {

        if (cartBtn) {
            cartBtn.classList.remove("atha-sticky-loading");
            cartBtn.removeAttribute("disabled");
        }

        if (buyBtn) {
            buyBtn.classList.remove("atha-sticky-loading");
            buyBtn.removeAttribute("disabled");
        }

    }, 10000);


    /* =========================================
       VARIANT STATE
    ========================================= */

    function updateStickyBar(variant) {

        if (!variant) return;

        if (variant.available) {

            buttons.style.display = "flex";
            soldBtn.style.display = "none";

        } else {

            buttons.style.display = "none";
            soldBtn.style.display = "flex";

        }

    }


    /* =========================================
       INITIAL STATE
    ========================================= */

    const addButton = document.querySelector('button[name="add"]');

    if (addButton && addButton.disabled) {

        buttons.style.display = "none";
        soldBtn.style.display = "flex";

    } else {

        buttons.style.display = "flex";
        soldBtn.style.display = "none";

    }


    /* =========================================
       VARIANT CHANGE
    ========================================= */

    if (
        typeof subscribe !== "undefined" &&
        typeof PUB_SUB_EVENTS !== "undefined"
    ) {

        subscribe(PUB_SUB_EVENTS.variantChange, function ({ data }) {

            updateStickyBar(data.variant);

        });

    }

});